/*
 * Sélecteur d'offre maison (snippets/fm-offre-niveaux.liquid), qui remplace le widget Kaching (15/10/2026).
 * Prix d'une carte = même calcul que la remise maison (Shopify Function, dépôt coalition-remises,
 * src/remises.js) et que snippets/fm-offre-prix.liquid, sur la config miroir de la boutique.
 * Les variantes d'une même carte sont toujours distinctes (deux niveaux différents).
 * À l'envoi : le panier est réglé sur le choix (les lignes du produit et du pack sont retirées, puis le
 * choix est ajouté à 1 exemplaire), puis le tiroir panier s'ouvre (cart:updated + cart:open).
 */
(function () {
  'use strict';

  function cents(amount) {
    return Math.round(Number(amount) * 100);
  }

  /** 9700 -> « 97€ », 7350 -> « 73,50€ » (format de snippets/fm-offre-euros.liquid). */
  function euros(c) {
    var e = Math.floor(c / 100);
    var r = c % 100;
    return e + (r ? ',' + (r < 10 ? '0' : '') + r : '') + '€';
  }

  function accepts(offer, gid) {
    var allowed = offer.produits || [];
    if (allowed.length && allowed.indexOf(gid) === -1) return false;
    return (offer.exclus || []).indexOf(gid) === -1;
  }

  function offerFor(cfg, gid) {
    if (!cfg || typeof cfg !== 'object') return null;
    var list = Array.isArray(cfg.offres) ? cfg.offres : cfg.mode ? [cfg] : [];
    for (var i = 0; i < list.length; i++) if (list[i] && accepts(list[i], gid)) return list[i];
    return null;
  }

  /**
   * Prix payé en centimes pour des unités d'un même produit.
   * @param {object|null} cfg Config miroir (coalition_remises.config).
   * @param {string} gid GID du produit.
   * @param {number[]} prices Prix unitaires en centimes.
   * @returns {number} Prix payé en centimes.
   */
  function lotCents(cfg, gid, prices) {
    var n = prices.length;
    var subtotal = prices.reduce(function (s, p) { return s + p; }, 0);
    var offer = offerFor(cfg, gid);
    var off = 0;
    if (offer && offer.mode === 'paliers' && Array.isArray(offer.paliers)) {
      offer.paliers.forEach(function (tier) {
        if (tier.quantite > n) return;
        var r = tier.prix !== undefined && tier.prix !== null
          ? subtotal - Math.round((cents(tier.prix) * n) / tier.quantite)
          : prices.reduce(function (s, p) { return s + Math.floor((p * tier.pourcentage) / 100); }, 0);
        if (r > off) off = r;
      });
    } else if (offer && offer.mode === 'bogo' && offer.bogo) {
      var b = offer.bogo;
      var count = Math.floor(n / (b.achete + b.offert)) * b.offert;
      prices.slice().sort(function (a, c) { return a - c; }).slice(0, count).forEach(function (p) {
        off += Math.floor((p * b.pourcentage) / 100);
      });
    }
    return subtotal - off;
  }

  function readJson(root, selector) {
    try {
      return JSON.parse(root.querySelector(selector).textContent);
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    var cfg = readJson(root, '[data-fmo-cfg]');
    var variants = readJson(root, '[data-fmo-variants]') || [];
    var gid = root.dataset.productGid;
    var form = document.getElementById(root.dataset.form);
    var button = document.getElementById(root.dataset.button);
    var error = root.querySelector('[data-fmo-error]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fmo-card]'));
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });
    var packIds = cards.filter(function (c) { return c.dataset.pack; }).map(function (c) { return Number(c.dataset.pack); });
    var managed = variants.map(function (v) { return v.id; }).concat(packIds);

    function selects(card) {
      return Array.prototype.slice.call(card.querySelectorAll('[data-fmo-select]'));
    }

    function chosenIds(card) {
      if (card.dataset.pack) return [Number(card.dataset.pack)];
      return selects(card).map(function (s) { return Number(s.value); });
    }

    function selectedCard() {
      return cards.filter(function (c) { return c.querySelector('.fmo-card__input').checked; })[0] || cards[0];
    }

    function cardPrice(card) {
      if (card.dataset.pack) return null;
      var chosen = chosenIds(card).map(function (id) { return byId[id]; });
      var paid = lotCents(cfg, gid, chosen.map(function (v) { return v.price; }));
      var full = chosen.reduce(function (s, v) { return s + Math.max(v.compare, v.price); }, 0);
      return { paid: paid, full: full };
    }

    function render() {
      cards.forEach(function (card) {
        var price = cardPrice(card);
        if (price) {
          card.querySelector('[data-fmo-price]').textContent = euros(price.paid);
          var fullEl = card.querySelector('[data-fmo-full]');
          fullEl.textContent = euros(price.full);
          fullEl.hidden = price.full <= price.paid;
        }
        selects(card).forEach(function (s) {
          var img = s.parentNode.querySelector('[data-fmo-img]');
          var v = byId[s.value];
          if (img && v && v.image) img.src = v.image;
          s.dataset.prev = s.value;
        });
      });
      var card = selectedCard();
      if (!card) return;
      var label = card.querySelector('[data-fmo-price]').textContent;
      if (button) {
        var live = button.querySelector('.btn-live');
        var arrow = button.querySelector('.btn-arrow');
        button.textContent = '';
        if (live) button.appendChild(live);
        button.appendChild(document.createTextNode('Ajouter au panier · ' + label));
        if (arrow) button.appendChild(arrow);
      }
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = chosenIds(card)[0];
    }

    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-fmo-select]');
      if (s) {
        // Niveaux distincts : si l'autre menu avait déjà ce niveau, il prend l'ancien niveau de celui-ci.
        selects(s.closest('[data-fmo-card]')).forEach(function (other) {
          if (other !== s && other.value === s.value) other.value = s.dataset.prev;
        });
      }
      if (error) error.hidden = true;
      render();
    });

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Erreur panier');
          return data;
        });
      });
    }

    function addToCart() {
      var ids = chosenIds(selectedCard());
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (item) {
            if (managed.indexOf(item.variant_id) !== -1) updates[item.key] = 0;
          });
          return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
        })
        .then(function () {
          return post('/cart/add.js', { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new Event('cart:open'));
        });
    }

    if (form) {
      // Écouteur sur le formulaire : passe avant celui du tiroir panier (document), qu'on arrête.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
        addToCart()
          .catch(function (err) {
            if (error) {
              error.textContent = "Impossible d'ajouter au panier : " + err.message;
              error.hidden = false;
            }
          })
          .then(function () {
            if (button) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
            }
          });
      });
    }

    render();
  }

  if (typeof document !== 'undefined') {
    var start = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fmo]'), init);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }

  if (typeof module !== 'undefined') module.exports = { lotCents: lotCents, euros: euros };
})();
